import PropTypes from 'prop-types';
import React, {memo, useEffect, Fragment} from 'react';
import { List } from 'immutable';
import defer from 'lodash/defer';

import StationFinderOpenMapsPin from './StationMarker';
import { useMap } from '../../openMap/MapContext';


const StationGroup = ({stations, onSelect}) => {
    const { map } = useMap();

    useEffect(()=> {
        if (stations.size && map) {
            defer(() => map.fitBounds(stations.map((s) => s.getLatLng()).toArray(), {padding: [10, 10]}));
        }
    }, [stations, map]);

    return (<Fragment>
        { stations &&
        stations.map((station) => <StationFinderOpenMapsPin key={ station.nlc } station={ station } onSelect={ onSelect } />) }
    </Fragment>);
};

StationGroup.propTypes = {
    stations: PropTypes.instanceOf(List).isRequired,
    onSelect: PropTypes.func.isRequired
};

export default memo(StationGroup);



// WEBPACK FOOTER //
// ./src/components/stationFinder/OpenStreetMaps/StationGroup.js